import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPlus, FaMinus } from 'react-icons/fa';
import './FAQSection.css';

const faqData = [
  {
    question: "What is Stocks4u?",
    answer: "Stocks4U is an institutional-grade, technology-based stock market data filtering and analysis platform designed to help users view, organize, and analyze market-related data with precision."
  },
  {
    question: "Who can use Stocks4u?",
    answer: "Whether you are an elite alpha trader, a long-term investor, or a beginner looking for a powerful tool, Stocks4U provides the real-time screeners, charts, and technical indicators you need to analyze the market."
  },
  {
    question: "Does Stocks4u offer educational resources for beginners?",
    answer: "Yes, Stocks4U provides intuitive educational tools, advanced technical indicators, and comprehensive market data that make it easy for beginners to learn and analyze market trends."
  }
];

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-container-premium">
      <h2 className="faq-title-main">Your questions, answered here.</h2>
      
      <div className="faq-list">
        {faqData.map((faq, index) => {
          const isOpen = openIndex === index;
          return (
            <motion.div 
              key={index}
              className={`faq-item-card ${isOpen ? 'open' : ''}`}
              onClick={() => toggleFAQ(index)}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
            >
              <div className="faq-item-header">
                <h3 className="faq-question">{faq.question}</h3>
                <div className={`faq-toggle-icon ${isOpen ? 'active' : ''}`}>
                  {isOpen ? <FaMinus /> : <FaPlus />}
                </div>
              </div>
              
              <AnimatePresence>
                {isOpen && (
                  <motion.div 
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3, ease: 'easeInOut' }}
                    className="faq-answer-container"
                  >
                    <p className="faq-answer">{faq.answer}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};

export default FAQSection;
